module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }